import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { APP_Constants } from 'src/app/app.constant';

@Component({
    selector: 'app-form-field-file-upload',
    templateUrl: './form-field-file-upload.component.html',
    styleUrls: ['./form-field-file-upload.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldFileUploadComponent implements OnInit {

  constructor(private appService: AppService) { }

  @Input() configData;
  @Input() frmGroup;

  fileToUpload: File = null;
  filesToUpload: File[] = [];
  showFileName: boolean = true;
  uploadUrl: string = '';
  uploadMsg: string = '';
  showError: boolean = false;
  fileToUploadForView: any;

  ngOnInit() {
    if(this.configData.required == true){
      this.showError = true;
    }
    if(this.configData.validation.length)
      this.fieldValueValidation(this.configData.validation);
    if (this.configData['editable'] === false) {
      this.frmGroup.get(this.configData.name).disable();
    }
    if (this.configData?.fileUploadForCtrlSub && this.frmGroup.get('fileUploadForCtrlSub')?.value) {
      this.fileToUploadForView = this.frmGroup.get('fileUploadForCtrlSub')?.value;
    }
    console.log(this.configData);
    console.log(this.frmGroup);
    if (this.configData.uploadUrl) {
      if(this.configData.urlType){
        this.configData.urlType === 'full' ? this.uploadUrl = this.configData.uploadUrl : this.uploadUrl = this.configData.uploadUrl + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName');
      } else{
        this.uploadUrl = this.configData.uploadUrl + localStorage.getItem('customerCode') +
        '&userId=' + localStorage.getItem('userName');
      }      
    }
  }

  handleFileInput(files: FileList) {
    const isSuperUser = this.isMultipleUploadAllowed;
    if (isSuperUser) {
      this.filesToUpload = Array.from(files).map(file =>
        new File([file], file.name.replace(/\s+\./g, '.'), { type: file.type })
      );
      this.appService.setUploadFileData(this.filesToUpload);
      const srcCtrlKey = this.configData['name'] + 'Src';
      if (this.frmGroup.contains(srcCtrlKey)) {
        this.frmGroup.patchValue({ [srcCtrlKey]: this.filesToUpload });
      }
    } else {
      this.fileToUpload = files.item(0);
      //  NCP-11557 Trim leading or trailing spaces in the file name when user uploads a document in OMP (DE487095)
      if (this.fileToUpload) {
        this.fileToUpload = new File([this.fileToUpload], this.fileToUpload.name.replace(/\s+\./g, '.'), { type: this.fileToUpload.type });
      }
      //  NCP-11557 ends
      this.appService.setUploadFileData(this.fileToUpload);
      // to support multiple document upload along with file upload control we have hidden file upload source control
      // patch File to hidden upload source control
      const srcCtrlKey = this.configData['name'] + 'Src';
      if (this.frmGroup.contains(srcCtrlKey)) {
        this.frmGroup.patchValue({
        [srcCtrlKey]: this.fileToUpload });
      }
    }
    if(this.configData.fileUploadForCtrlSub){
      this.fileUploadForCtrlSubEvent(this.configData.statusControlConfig)
    }
    this.showFileName = true;
}

  fileUploadForCtrlSubEvent(statusControlConfig) {
    const statusControl = this.frmGroup.get(statusControlConfig.status);
    const messageControl = this.frmGroup.get(statusControlConfig.message);
    const transactionIdControl = this.frmGroup.get(statusControlConfig.transactionId);
    statusControl.reset();
    messageControl.reset();
    transactionIdControl.reset();
    this.frmGroup.get(statusControlConfig.status).updateValueAndValidity();
    this.frmGroup.get(statusControlConfig.message).updateValueAndValidity();
    this.frmGroup.get(statusControlConfig.transactionId).updateValueAndValidity();


    let eventData: any = {
      action: "UPLOAD_DOC_CTRL_SUB",
      name: "uploadDoc",
      component: this,
      statusControlConfig : statusControlConfig,
      configData: this.configData,
      fileData: this.appService.getUploadFileData(),
      parentFormGroup: this.frmGroup
    }
    this.appService._commonComponentSubject.next(eventData);
    this.frmGroup.get(this.configData.name).markAsTouched();

  }
  // need to remove below method
  uploadFileToActivity() {
    this.appService.makeHttpFileUploadRequest(this.uploadUrl,this.fileToUpload).subscribe(data => {
      if(data['statusCode'] === APP_Constants.SUCCESS_CODE ){
        this.uploadMsg = data['statusMessage'];
        console.log(data['statusMessage']);
      }
      // do something, if upload success
      }, error => {
        console.log(error);
        this.uploadMsg = error['message'];
      });
  }
  modalOnClick(modal, ctrl){
    //let vin = this.frmGroup.get('stepTwo')['controls'][0].controls.vin.value;
    let eventData: any = {
      action: "MODAL",
      name: "modal",
      component: this,
      configData: modal[0].actions,
      parentfrmGroup: this.frmGroup?.get(ctrl?.name) ?? "",
      data: {modal} 
    }
    this.appService._commonComponentSubject.next(eventData);
    this.frmGroup.get(this.configData.name).markAsTouched();
  }
  browse(modal){
    //let vin = this.frmGroup.get('stepTwo')['controls'][0].controls.vin.value;
    let eventData: any = {
      action: "MODAL",
      name: modal.type || "link/pdf",
      frmGrp: this.frmGroup?.controls,
      component: this,
      data: {modal} 
    }
    this.appService._commonComponentSubject.next(eventData);
    this.frmGroup.get(this.configData.name).markAsTouched();
  }

  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;          
          this.configData.required = false;                    
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }

    });
  }

  toggleVisibility(hidden = !this.frmGroup.get(this.configData.name)['hidden']){
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    this.frmGroup.get(this.configData.name).reset();
    this.frmGroup.get(this.configData.name).updateValueAndValidity();
  }
  onReset(){
    this.showFileName = false;
  }

  get fileAcceptType(): string {
    return localStorage.getItem('filterCurrenturl') === '/upload_csv' ? '.csv' : '.xlsx';
  }

  get isMultipleUploadAllowed(): boolean {
    const userRole = localStorage.getItem('userRole');
    return Array.isArray(this.configData?.allowedRoles) && this.configData.allowedRoles.includes(userRole);
  }
}
